<script setup lang="ts" generic="T extends Array<Record<string, any>>">
const props = defineProps<{ items: T }>();
</script>

<template>
    <div class="flex flex-col gap-8 items-center">
        <div
            v-for="item, index in props.items"
            :key="item.title"
            :id="item.title"
            class="w-full flex flex-col items-center gap-6 py-6 px-4 bg-gray-50 border border-gray-100 rounded-xl relative"
        >
            <svg 
                class="absolute w-45 h-35 blur-3xl rounded-full bottom-20 left-10"
                :class="[
                    index === 0 && 'bg-primary-200',
                    index === 1 && 'bg-success-200',
                    index === 2 && 'bg-warning-200',
                ]"
            ></svg>           
            <div class="w-full relative z-1">
                <h3 class="text-center">{{ item.title }}</h3>
                <p class="text-body1 text-gray-400 text-center mt-3">{{ item.desc }}</p>
                <div class="w-full flex flex-col gap-6">
                <div
                    v-for="group in item.groups"
                    :key="group.title"
                    class="w-full mt-6"
                >
                    <div class="w-full flex items-center gap-3">
                    <Icon name="solar:check-circle-bold" size="24" class="text-secondary-600" />
                    <span class="h4">{{ group.title }}</span>
                    </div>
                    <p class="text-body1 text-gray-400 mt-3">{{ group.desc }}</p>
                </div>
                </div>
            </div>
            <img
                :src="item.img"
                :alt="item.title"
                class="w-full relative z-1"
                loading="lazy"
            />
        </div>
    </div>
</template>